<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Log Book">
      <v-card-actions>
        <v-btn
          v-if="submodules.AdminLogBook"
          absolute
          right
          top
          elevation="1"
          @click="$router.push({ name: 'topicLists' })"
          :class="{ 'mt-4': $vuetify.breakpoint.xs, 'ml-4': $vuetify.breakpoint.smAndUp }"
          color="accent"
          type="submit"
        >
          <v-icon left>mdi-plus</v-icon>Add Topic
        </v-btn>
      </v-card-actions>

      <div v-if="submodules.teacherLogBook && isSuperAdmin === false ">
        <v-card flat class="px-2">
          <form>
            <v-row>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">From Date</label>
                <custom-date-picker @input="fromDateChange(),clearAll()" v-model="fromDate" />
              </v-col>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">To Date</label>
                <custom-date-picker v-model="toDate" :minToDate="fromDate" />
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Select Class
                  <span class="error--text">*</span>
                </label>
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--Select--"
                  name="classSelect"
                  required
                  v-model="selectedClassID"
                  v-on:change="changeSections(), clearAll()"
                  item-value="id"
                  :items="classes"
                  key="id"
                  item-text="name"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Select Section
                  <span class="error--text">*</span>
                </label>

                <v-autocomplete
                  class="my-0 py-1"
                  name="selectedSectionID"
                  v-model="selectedSectionID"
                  item-value="id"
                  :items="classWiseSections"
                  key="id"
                  item-text="name"
                  disabled
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="body-2 font-weight-medium">Actions</label>
                <div class="inside">
                  <v-btn color="success" elevation="1" @click="saveByTeacher()">
                    <v-icon left size="20">mdi-equal-box</v-icon>Apply
                  </v-btn>
                  <v-btn
                    @click="$router.push({ name: 'addLogBookEntry' })"
                    v-if="applyBtnClicked"
                    bottom
                    right
                    elevation="1"
                    color="primary"
                    type="submit"
                    class="addLogBtn"
                  >
                    <v-icon left>mdi-plus</v-icon>Add Log Book Entry
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </form>
        </v-card>
        <v-card-component>
          <v-card-text
            class="pt-0 pr-1"
            :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }"
          >
            <!-- <v-card-title>
            <v-spacer></v-spacer>
            </v-card-title>-->
          </v-card-text>
          <v-divider class="my-0" />
          <v-data-table
            :headers="headers"
            :items="logData"
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
          >
            <!-- <template v-slot:item.title="{ item }">
            {{ item.title || '---' }}
            </template>-->
            <template
              v-slot:item.Date="{ item }"
            >{{ new Date(item.Date).toLocaleDateString() || '-' }}</template>

            <template v-slot:item.actions="{ item }">
              <router-link
                v-if="!item.isPublish && isEdit(item.Date, currentDate)"
                :to="{ name: 'editLogBookEntry', params: { logBookID: item.id } }"
              >
                <v-btn outlined class="px-2 ml-1 ma-1" color="success" min-width="0" small>
                  Edit Log
                  <!-- <v-icon small> mdi-pencil </v-icon> -->
                </v-btn>
              </router-link>
              <span v-if="item.isPublish===false && isAfterDate(item.Date, currentDate)">
                <v-btn
                  @click="submitLog(item.id)"
                  outlined
                  class="px-2 ml-1 ma-1"
                  color="success"
                  min-width="0"
                  small
                >
                  Submit
                  <!-- <v-icon small> mdi-pencil </v-icon> -->
                </v-btn>
              </span>
              <router-link :to="{ name: 'viewLogBookEntry', params: { logBookID: item.id } }">
                <v-btn outlined class="px-2 ml-1 ma-1" color="accent" min-width="0" small>
                  View Log
                  <!-- <v-icon color="black" small> mdi-eye </v-icon> -->
                </v-btn>
              </router-link>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </div>
      <!-- for bussiness partner --->
      <div v-if="submodules.AdminLogBook">
        <v-card flat class="px-2">
          <form>
            <v-row>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">From Date</label>
                <custom-date-picker @input="fromDateChange(),clearAll()" v-model="fromDate" />
              </v-col>
              <v-col cols="12" md="3">
                <label class="font-weight-medium body-2">To Date</label>
                <custom-date-picker v-model="toDate" :minToDate="fromDate" />
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Select Franchisee
                  <span class="error--text">*</span>
                </label>
                <v-autocomplete
                  class="my-0 py-1"
                  v-model="franchiseeID"
                  clearable
                  :items="centreList"
                  key="id"
                  v-on:change="getTeacherList(), clearAll()"
                  item-value="id"
                  item-text="companyName"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">Select Teacher</label>

                <v-autocomplete
                  class="my-0 py-1"
                  clearable
                  placeholder="--All Staff--"
                  name="sectionSelect"
                  v-model="staffID"
                  required
                  :items="staffOptions"
                  key="user.id"
                  item-value="user.userStaff.id"
                  item-text="user.firstName"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="body-2 font-weight-medium">Actions</label>
                <div class="inside">
                  <v-btn color="success" elevation="1" @click="save()">
                    <v-icon left>mdi-equal-box</v-icon>Apply
                  </v-btn>
                  <!-- <v-btn @click="$router.push({ name: 'addLogBookEntry' })" v-if="applyBtnClicked"
                  bottom right elevation="1" color="primary" type="submit" class="addLogBtn">
                  <v-icon left> mdi-plus </v-icon>
                  Add Log Book Entry
                  </v-btn>-->
                </div>
              </v-col>
            </v-row>
          </form>
        </v-card>
        <v-card-component>
          <v-card-text
            class="pt-0 pr-1"
            :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }"
          >
            <!-- <v-card-title>
            <v-spacer></v-spacer>
            </v-card-title>-->
          </v-card-text>
          <v-divider class="my-0" />
          <v-data-table
            :headers="ssnHeaders"
            :items="logData"
            :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }"
            :items-per-page="10"
          >
            <!-- <template v-slot:item.title="{ item }">
            {{ item.title || '---' }}
            </template>-->
            <template
              v-slot:item.teacherName="{ item }"
            >{{ item.teacherName[0].user.firstName+" "+ item.teacherName[0].user.lastName}}</template>
            <!-- <template v-slot:item.Date="{ item }">
              {{ new Date(item.Date).toLocaleDateString() || '-' }}
            </template>-->
            <template v-slot:item.actions="{ item }">
              <router-link
                :to="{ name: 'viewLogBookEntryList', params: { teacherID: item.teacherName[0].id} }"
              >
                <v-btn outlined class="px-2 ml-1 ma-1" color="accent" min-width="0" small>
                  View Log
                  <!-- <v-icon color="black" small> mdi-eye </v-icon> -->
                </v-btn>
              </router-link>
            </template>
            <template v-slot:no-data>
              <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
            </template>
          </v-data-table>
        </v-card-component>
      </div>
      <!--- end --->
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Utils from '@/utils'
import _ from 'lodash'
import stores from '@/stores'

export default {
  name: 'logBookLists',
  components: {
    MaterialCard,
    CustomDatePicker,
    VCardComponent
  },

  data () {
    const today = new Date()
    return {
      submodules: {
        teacherLogBook: this.checkModuleAccess('teacherLogBook'),
        AdminLogBook: this.checkModuleAccess('AdminLogBook')
      },
      total: 0,
      date: moment().format('YYYY-MM-DD'),
      fromDate: '',
      toDate: '',
      currentDate: new Date().toISOString().slice(0, 10),
      mindate: new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString().slice(0, 10),
      franchiseeID: '',
      franchiseeArr: [],
      academicYearID: '',
      inProgress: false,
      classSection: '',
      classSectionArray: [],
      selectedClassSectionArray: [],
      // GeneralRemark: '',
      logData: [],
      temp: '',
      type: '',
      search: '',
      academicYears: [],
      selectedClassID: '',
      selectedSectionID: '',
      name: '',
      title: '',
      classWiseSections: [],
      classes: [],
      sections: [],
      studentArray: [],
      hasClicked: false,
      loader: true,
      applyBtnClicked: false,
      isLoading: false,
      isWrite: false,
      staffOptions: [],
      staffID: '',
      id: '',
      isSuperAdmin: false,
      user: stores.user.me,
      centreList: [],
      logId: '',
      headers: [
        { text: 'Date', value: 'Date', sortable: false },
        { text: 'Action', value: 'actions', sortable: false, align: 'center' }
      ],
      ssnHeaders: [
        { text: 'Teacher Name', value: 'teacherName' },
        // { text: 'Created Date', value: 'Date' },
        { text: 'Actions', value: 'actions' }
      ]
    }
  },

  async created () {
    await this.onFranchiseeChange()
    await this.getFranchisee()

    this.getLogBookLists()
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    this.isSuperAdmin = await Utils.helper.isSuperAdmin()
    if (this.submodules.teacherLogBook && !this.isSuperAdmin) {
      this.getLogsByTeacher()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    fromDateChange: async function () {
      if (moment(this.fromDate).isAfter(this.toDate)) {
        this.toDate = this.fromDate
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (this.franchiseeID && this.academicYearID) {
          await this.getClassList()
        }
        if (this.franchiseeID) {
          await this.getTeacherList()
        }
        this.clearAll()
        this.resetAll()
        this.inProgress = false
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=true`)
        if (data) {
          this.classes = data
          this.sections = data
        }

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },

    changeSections: async function () {
      try {
        this.isLoading = true
        this.classWiseSections = []
        this.selectedSectionID = ''
        let searchIndex = this.classes.map(a => a.id).indexOf(this.selectedClassID)
        if (searchIndex > -1) {
          this.classWiseSections = this.classes[searchIndex].studentSections
          if (this.classWiseSections.length > 0) {
            this.selectedSectionID = this.classWiseSections[0]?.id || ''
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    save: async function () {
      try {
        this.applyBtnClicked = true
        if (!this.franchiseeID) {
          this.errMsg('Please select Franchisee')
          return false
        }
        if (this.franchiseeID.length === 0) {
          this.isLoading = false
          return this.$dialog.message.error('Please select franchisee', {
            position: 'top',
            timeout: 3000
          })
        }

        let rows = await http.get(`${constants.API_URL}/api/log-book/getall`, {
          params: {
            franchiseeID: this.franchiseeID,
            fromDate: this.fromDate,
            toDate: this.toDate,
            classID: this.selectedClassID,
            sectionID: this.selectedSectionID.toString(),
            teacherID: this.staffID
          }
        })
        if (rows.data.rows.length === 0) {
          this.$dialog.message.error('No Data Found', {
            position: 'top',
            timeout: 4000
          })
        } else {
          this.Date = rows.data.Date
          this.logData = rows.data.rows.map(item => {
            return item
          })
          // this.logData = _.uniqBy(this.logData, 'id')
          if (!this.submodules.teacherLogBook || this.isSuperAdmin === true) {
            // this.logData = _.uniqBy(this.logData, 'id')
          }
          this.totalPages = rows.data.totalPages
        }

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    saveByTeacher: async function () {
      try {
        this.applyBtnClicked = true
        if (this.franchiseeID.length === 0) {
          this.isLoading = false
          return this.$dialog.message.error('Please select franchisee', {
            position: 'top',
            timeout: 3000
          })
        }
        this.teacherID = stores.user.me.userStaff.id
        let rows = await http.get(`${constants.API_URL}/api/log-book/getall`, {
          params: {
            franchiseeID: this.franchiseeID,
            fromDate: this.fromDate,
            toDate: this.toDate,
            classID: this.selectedClassID,
            sectionID: this.selectedSectionID.toString(),
            teacherID: this.teacherID
          }
        })
        if (rows.data.rows.length === 0) {
          this.$dialog.message.error('No Data Found', {
            position: 'top',
            timeout: 4000
          })
        } else {
          this.Date = rows.data.Date
          this.logData = rows.data.rows.map(item => {
            return item
          })

          if (!this.submodules.teacherLogBook || this.isSuperAdmin === true) {
            this.logData = _.uniqBy(this.logData, 'id')
          }
          this.totalPages = rows.data.totalPages
        }

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getLogBookLists: async function () {
      try {
        // if (this.submodules.teacherLogBook && this.isSuperAdmin === false) {

        // }
        let rows = await http.get(`${constants.API_URL}/api/log-book/getall`, {
          params: {
            franchiseeID: this.franchiseeID,
            fromDate: this.fromDate,
            toDate: this.toDate,
            classID: this.selectedClassID,
            sectionID: this.selectedSectionID.toString(),
            teacherID: this.staffID
          }
        })
        if (rows.data.rows.length === 0) {
          this.$dialog.message.warning('No Data Found', {
            position: 'top',
            timeout: 4000
          })
        }

        this.Date = rows.data.Date

        this.logData = rows.data.rows.map(item => {
          this.logBookID = item.id
          this.teacherID = item.teacherName[0].id
          return item
        })
        if (!this.submodules.teacherLogBook || this.isSuperAdmin === true) {
          this.logData = _.uniqBy(this.logData, 'teacherID')
        }
        this.totalPages = rows.data.totalPages
      } catch (e) {
        console.log(e)
        return this.$dialog.error({
          text: (e && e.response && e.response.data.message) || e.message,
          title: 'Error'
        })
      }
    },
    getLogsByTeacher: async function () {
      try {
        this.teacherID = stores.user.me.userStaff.id
        console.log(this.teacherID, 'userstaff id')
        let rows = await http.get(`${constants.API_URL}/api/log-book/getlogbook/${this.teacherID}`, {
          params: {
            franchiseeID: this.franchiseeID,
            fromDate: this.fromDate,
            toDate: this.toDate,
            classID: this.selectedClassID,
            sectionID: this.selectedSectionID.toString()
          }
        })
        if (rows.data.rows.length === 0) {
          this.$dialog.message.warning('No Data Found', {
            position: 'top',
            timeout: 4000
          })
        }

        this.Date = rows.data.Date

        this.logData = rows.data.rows.map(item => {
          this.logBookID = item.id
          this.teacherID = item.teacherName[0].id
          return item
        })
        if (!this.submodules.teacherLogBook || this.isSuperAdmin === true) {
          this.logData = _.uniqBy(this.logData, 'teacherID')
        }
        this.totalPages = rows.data.totalPages
      } catch (e) {
        console.log(e)
        return this.$dialog.error({
          text: (e && e.response && e.response.data.message) || e.message,
          title: 'Error'
        })
      }
    },
    isEdit (logdate, currentDate) {
      currentDate = moment(currentDate).format('YYYY-MM-DD')
      logdate = moment(logdate).format('YYYY-MM-DD')
      // console.log(currentDate, logdate, 'Date')
      if (currentDate <= logdate) {
        return true
      } else {
        return false
      }
    },
    isAfterDate (logdate, currentDate) {
      currentDate = moment(currentDate).format('YYYY-MM-DD')
      logdate = moment(logdate)
      return logdate.isBefore(currentDate)
    },
    getFranchisee: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/franchisee/active`)
        this.centreList = res.data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getTeacherList: async function () {
      let rows = await http.get(`${constants.API_URL}/api/staff/approved`, {
        params: {
          franchiseeID: this.franchiseeID,
          isTeachingStaff: true
        }
      })

      this.staffOptions = rows.data
    },
    submitLog: async function (logId) {
      try {
        this.isLoading = true
        let formData = {
          isPublish: true
        }
        this.id = logId
        // console.log(this.id, 'ID item')
        let res = await http.put(`${constants.API_URL}/api/log-book/save/${this.id}`, formData)
        this.okMsg(res.data)
        this.isLoading = true
        window.location.reload()
        this.getTeacherList()
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    clearAll: async function () {
      this.generalDiary = []
      this.temp = ''
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    resetAll: async function () {
      this.fromDate = ''
      this.toDate = ''
      this.selectedClassID = ''
      this.selectedSectionID = ''
    }
  }
}
</script>
<style>
.addLogBtn {
  margin-left: 30px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
